import { render, staticRenderFns } from "./paginationChange.vue?vue&type=template&id=39e28817&scoped=true&"
import script from "./paginationChange.vue?vue&type=script&lang=js&"
export * from "./paginationChange.vue?vue&type=script&lang=js&"
import style0 from "./paginationChange.vue?vue&type=style&index=0&id=39e28817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e28817",
  null
  
)

export default component.exports